import { connect, ConnectedProps } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { RootState } from '../../../store'
import TasksComponent from '../components/TasksComponent'
import {
  getTasks,
  getTaskSummary,
  transitionTask,
  commentTask,
  bulkCloseTasks,
} from '../actions'
import { ITaskFilters } from '../services'
import { getCompany } from '../../center/actions'
import { CompanyType } from '../../../common/interfaces'

const mapStateToProps = (state: RootState) => ({
  token: state.authReducer.token,
  tasks: state.tasksReducer.tasks,
  totalPages: state.tasksReducer.totalPages,
  summary: state.tasksReducer.summary,
  loading: state.tasksReducer.loading,
  centers: state.centersReducer.centers.data,
  // Les rôles d'exploitation voient tous les centres : eux seuls ont besoin du
  // filtre. Un utilisateur de centre est borné à sa société côté API.
  roles:
    state.authReducer.user?.userDataRoles.map((role: any) => role.roleName) ??
    [],
})

const mapDispatchToProps = (dispatch: any) => ({
  getTasks: (size: number, page: number, filters: ITaskFilters) =>
    new Promise((resolve: any, reject: any) => {
      dispatch(getTasks(size, page, filters, null, resolve, reject))
    }),
  getTaskSummary: () =>
    new Promise((resolve: any, reject: any) => {
      dispatch(getTaskSummary(resolve, reject))
    }),
  transitionTask: (
    id: string,
    status: 'DONE' | 'REJECTED',
    comment: string | undefined,
  ) =>
    new Promise((resolve: any, reject: any) => {
      dispatch(transitionTask(id, status, comment, resolve, reject))
    }),
  commentTask: (id: string, comment: string) =>
    new Promise((resolve: any, reject: any) => {
      dispatch(commentTask(id, comment, resolve, reject))
    }),
  bulkCloseTasks: (ids: string[]) =>
    new Promise((resolve: any, reject: any) => {
      dispatch(bulkCloseTasks(ids, resolve, reject))
    }),
  getCenters: () =>
    new Promise((resolve: any, reject: any) => {
      dispatch(
        getCompany(1000, 0, '', undefined, CompanyType.CENTER, resolve, reject),
      )
    }),
})

const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromReduxTasks = ConnectedProps<typeof connector>

export default withRouter(connector(TasksComponent) as any)
